import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ExPill, PillColor } from '@boomi/exosphere';
import { generateUniqueKey, transformApiResponseToWizardData } from '@services/agent-foundation/agent-foundation-api-service';
import './AgentPreview.scss';
import ProfileSection from '@components/AgentBuilder/ProfileSection/ProfileSection';
import GuardrailSection from '@components/AgentBuilder/GuardrailSection/GuardrailSection';
import TaskSection from '@components/AgentBuilder/TaskSection/TaskSection';

function AgentPreview({
  importPreviewDetails,
  sources,
  isAgentAlreadyCreated = false,
  isReadyToUseTemplate = false,
}: any) {
  const builderSteps = ['Profile', 'Tasks', 'Guardrails'];
  const [t] = useTranslation('common');
  const [selectedBuilderStep, setSelectedBuilderStep] = useState('Profile');
  const handleBuilderStep = (step: any) => {
    setSelectedBuilderStep(step);
  };
  const renderComponent = () => {
    let template = importPreviewDetails;
    if (template) {
      const previewTemplate = transformApiResponseToWizardData(template);
      // Add unique id to each task if tasks exist and don't already have an id
      if (template?.tasks?.length > 0) {
        template.tasks = template.tasks.map((task: any, idx: number) => ({
          ...task,
          id: task.id || `task-${idx}-${generateUniqueKey(idx)}`,
        }));
      }

      if (template?.agent_mode === 'structured') {
        template = {
          ...template,
          input_json_schema: template.input_schema || '{}',
          output_json_schema: template.output_schema || '{}',
        };
      }

      switch (selectedBuilderStep) {
        case 'Profile':
          return <ProfileSection template={template} />;
        case 'Tasks':
          return (
            <TaskSection
              template={template}
              sources={sources}
              showToolBanner
              isAgentAlreadyCreated={isAgentAlreadyCreated}
              isReadyToUseTemplate={isReadyToUseTemplate}
            />
          );
        case 'Guardrails':
          return <GuardrailSection template={previewTemplate?.guardrails?.data} />;
        default:
          return <ProfileSection template={template} />;
      }
    }
    return null;
  };
  return (
    <>
      <div className="builder-steps-container">
        {builderSteps.map((builderStep: any, index: number) => (
          <ExPill
            key={generateUniqueKey(index)}
            interactive
            selected={builderStep === selectedBuilderStep}
            color={builderStep === selectedBuilderStep ? PillColor.AQUA : undefined}
            onClick={() => handleBuilderStep(builderStep)}
          >
            {builderStep === 'Tasks' ? t('review_panel_task_title') : builderStep}
          </ExPill>
        ))}
      </div>
      <div className="template-preview-section">
        {renderComponent()}
      </div>
    </>
  );
}
export default AgentPreview;
